/* global axios */
import ApiClient from './ApiClient';

class CrmMetricsAPI extends ApiClient {
  constructor() {
    super('crm_metrics', { accountScoped: true });
  }

  get(period = 'monthly') {
    return axios.get(this.url, { params: { period } });
  }
}

export default new CrmMetricsAPI();
